var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"label-switch"},_vm._l((_vm.options),function(option){return _c('li',{key:option.value,class:{
      active: option.value === _vm.value
    },on:{"click":function($event){return _vm.onclick(option)}}},[_vm._v(_vm._s(option.label))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa5a950","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelSwitch/index.vue
// module id = null
// module chunks = 